import { render, staticRenderFns } from "./homeNavigation2.vue?vue&type=template&id=aae44702&scoped=true"
import script from "./homeNavigation2.vue?vue&type=script&lang=js"
export * from "./homeNavigation2.vue?vue&type=script&lang=js"
import style0 from "./homeNavigation2.vue?vue&type=style&index=0&id=aae44702&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aae44702",
  null
  
)

export default component.exports